// extracted by mini-css-extract-plugin
export var content = "_ot-1";
export var fullScreen = "_ot-0";